import React from "react";
import parse from "html-react-parser";

export default function AwardsSection({ sectionTitle, sectionTitleUp, sectionSubTitle, data }) {
  return (
    <section className="cs_about_new_awards" style={ { backgroundImage: "url('/images/home_1/banner_bg1.png')" } }>
      <div className="cs_awards_overlay"></div>
      <div className="container cs_relative">
        <div className="cs_awards_row">

          <div className="cs_awards_left">
            { sectionTitleUp && <h6 className="cs_section_subtitle">{ sectionTitleUp }</h6> }
            { sectionTitle && (
              <h2 className="cs_awards_title">
                { parse(sectionTitle) }
              </h2>
            ) }

            { sectionSubTitle && (
              <div className="cs_awards_quote">
                <span className="quote_icon left_quote">“</span>
                <p dangerouslySetInnerHTML={ { __html: sectionSubTitle } }></p>
              </div>
            ) }

            <div className="cs_awards_visual">
              <img src="/images/about_awwords.jpeg" alt="Awards Visual" className="cs_awards_img" />
            </div>
          </div>

          <div className="cs_awards_right">
            <div className="cs_awards_grid_glass">
              { data?.map((item, index) => (
                <div className="cs_award_glass_card" key={ index }>
                  <div className="cs_award_icon_glass">
                    <img src={ item.iconUrl } alt="Award Icon" />
                  </div>
                  <p className="cs_award_text_glass">{ item.title }</p>
                </div>
              )) }
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
